import { Box } from "@chakra-ui/react";
import { color } from "framer-motion";
import React, { Component } from "react";
import Slider from "react-slick";
import StudentDetails from "./StudentDetails";
import styles from "./StudentSlider.module.css";
const StudentsData = [
  {
    image:
      "https://i.postimg.cc/ZnQ9P903/abhishekkumar.png",
    name: "Abhishek Kumar",
    details:
      "Under Chandan Sir's guidance at sbpathshala, Abhishek Kumar excelled in JEE Mains 2022, a testament to the institution's effective teaching and personalized mentorship, highlighting its commitment to excellence. ",
      marks:""
  },
  {
    image:
      "https://i.postimg.cc/X7t9MPxW/rupkunar.png",
    name: "Rup Kumar",
    details:
      "Rup Kumar's success in JEE Mains 2022, under Chandan Sir's mentorship at sbpathshala, epitomizes the institution's commitment to personalized guidance and academic excellence. His achievement underscores the effectiveness of sbpathshala's teaching methods.",
      marks:""
    },
  {
    image:
      "https://i.postimg.cc/qRgsn6Gc/Amrit-Raj.png",
    name: "Amrit Raj",
    details:
      "  Guided by Chandan Sir at sbpathshala, Amrit Raj excelled in JEE Mains 2022, showcasing the institution's dedication to academic excellence and personalized mentorship. His success is a testament to sbpathshala's commitment to shaping students for extraordinary achievements.",
    marks: "",
  },
 
  
];
export default class AutoPlay extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 3000,
      autoplaySpeed: 2000,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 570,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],

      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      
      <div className={styles.slider} >
        <Slider {...settings}>
          {StudentsData.map((el, i) => {
            return (
              <div key={i}>
                <StudentDetails
                  image={el.image}
                  name={el.name}
                  marks={el.marks}
                  details={el.details}
                />
              </div>
            );
          })}
        </Slider>
      </div>
     
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <Box
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <Box
      className={className}
      style={{ ...style, display: "block", background: "black" }}
      onClick={onClick}
    />
  );
}
